import { Cra } from "./CRA";

export class CraBillingOptions {
  id?: number;
  defaultInvoicingTerms!: string;
  invoiceDisclaimer!: string;
  postChargesToInvoice?: boolean;
  sendBCCEmails?: boolean | 0;
  bccEmail?: string | null;
  //paymentGateway!: number | 0;
  //apiLoginId?: string | null;
  //transactionKey?: string | null;
  craId!: number;
  craDefaultBillingTermNames: Array<string>;

  constructor() {
    this.FetchCraDefaultBillingTermNames(CraDefaultBillingTerms);
  }

  FetchCraDefaultBillingTermNames(myEnum: any) {
    var tmpArray = Object.keys(myEnum).map(key => myEnum[key]).filter(value => typeof value === 'string') as string[];
    // now massage the names y coverting camelCase names to Capitalized words SWS
    tmpArray.forEach(value => {
      value.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1");
    });

    this.craDefaultBillingTermNames = tmpArray;
  }
}

export enum CraDefaultBillingTerms {
  Net14 = 0,
  Monthly30 = 1,
  DueOnReceipt = 3,
}
